module.exports = {"module":"cswap","path":"/zh-tw/cswap/description","name":"接口說明","content":[{"type":"html","text":"<li>GET方法的接口, 參數必須在query string中發送.</li>"},{"type":"html","text":"<li>POST, PUT, 和 DELETE 方法的接口, 參數可以在 query string 中發送，也可以在 request body 中發送(content type application/x-www-form-urlencoded)。<br>  允许混合這两種方式發送參數。但如果同一個參數名在 query string 和 request body 中都有，query string 中的會被優先採用。</li>"},{"type":"html","text":"<li>對參數的順序不做要求。</li>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/2_description.json
// module id = ihU3
// module chunks = 3